import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Divider from "@material-ui/core/Divider";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const SELECT_ALL = "__SELECT_ALL__";
const DESELECT_ALL = "__DESELECT_ALL__";

const TicketsQueueSelect = ({
	userQueues = [],
	selectedQueueIds = [],
	onChange,
}) => {

	const handleChange = e => {

		const values = e.target.value;

		console.log("TicketsQueueSelect values:", values);

		// ==============================
		// SELECCIONAR TODAS
		// ==============================
		if (values.includes(SELECT_ALL)) {

			const allQueueIds = userQueues.map(queue => queue.id);

			onChange(allQueueIds);

			return;
		}

		// ==============================
		// DESELECCIONAR TODAS
		// ==============================
		if (values.includes(DESELECT_ALL)) {

			onChange([]);

			return;
		}

		// ==============================
		// SELECCION NORMAL
		// ==============================
		onChange(values);
	};


	const allSelected =
		userQueues.length > 0 &&
		selectedQueueIds.length === userQueues.length;


	const noneSelected =
		selectedQueueIds.length === 0;


	return (
		<div style={{ width: 120, marginTop: -4 }}>

			<FormControl fullWidth margin="dense">

				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}

					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}

					renderValue={() =>
						i18n.t("ticketsQueueSelect.placeholder")
					}
				>

					{/* ========================= */}
					{/* SELECCIONAR TODAS */}
					{/* ========================= */}

					<MenuItem
						dense
						value={SELECT_ALL}
					>

						<Checkbox
							size="small"
							color="primary"
							checked={allSelected}
							indeterminate={
								selectedQueueIds.length > 0 &&
								!allSelected
							}
						/>

						<ListItemText
							primary="Seleccionar todas"
						/>

					</MenuItem>


					{/* ========================= */}
					{/* DESELECCIONAR TODAS */}
					{/* ========================= */}

					<MenuItem
						dense
						value={DESELECT_ALL}
					>

						<Checkbox
							size="small"
							color="primary"
							checked={noneSelected}
						/>

						<ListItemText
							primary="Deseleccionar todas"
						/>

					</MenuItem>


					<Divider />


					{/* ========================= */}
					{/* COLAS */}
					{/* ========================= */}

					{userQueues.map(queue => (

						<MenuItem
							dense
							key={queue.id}
							value={queue.id}
						>

							<Checkbox
								style={{
									color: queue.color,
								}}
								size="small"
								color="primary"
								checked={
									selectedQueueIds.indexOf(queue.id) !== -1
								}
							/>

							<ListItemText
								primary={queue.name}
							/>

						</MenuItem>

					))}

				</Select>

			</FormControl>

		</div>
	);
};

export default TicketsQueueSelect;